import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getIsRoomExists } from "../../services/api";
import { setIsTimeStamp } from "../../stories/actions";
import { toast } from "react-toastify";
import * as roomRTC from "../../services/roomRTC";

import Label from "../Labels/Label";
import TimerValues from "./TimerValues";

import audioSrc from "../../audios/initial_scenario.mp3";

import "./Room.css";

const TimerStamp = ({ isRoomHost, roomId, isTimeStamp, setIsTimeStampAction, initialMinutes, initialSeconds }) => {
    const [minutes, setMinutes] = useState(initialMinutes);
    const [seconds, setSeconds] = useState(initialSeconds);

    const handlerTimeStamp = async () => {
        const roomResponse = await getIsRoomExists(roomId);
        const { roomExists, full } = roomResponse;

        const notify = (message) => {
            toast(message);
        };

        if (roomExists && full) {
            setIsTimeStampAction(!isTimeStamp);
        } else {
            notify("Aguarde o ator para o treinamento...");
        }
    };

    useEffect(() => {
        if (isTimeStamp) {
            const interval = setInterval(() => {
                setSeconds((prevSeconds) => {
                    if (prevSeconds > 0) {
                        return prevSeconds - 1;
                    } else if (minutes > 0) {
                        setMinutes((prevMinutes) => prevMinutes - 1);
                        return 59;
                    } else {
                        clearInterval(interval);
                        return 0;
                    }
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [isTimeStamp, minutes]);

    useEffect(() => {
        roomRTC.sendTimeStampDataChannel(minutes, seconds, roomId);
    }, [minutes, seconds]);

    useEffect(() => {
        roomRTC.sendTimeAlertDataChannel(isTimeStamp, audioSrc, roomId);
    }, [isTimeStamp]);

    return (
        <div className="col-md-12 mb-2 time_stamp_container">
            <Label text="TEMPO DE TREINAMENTO" />

            {isRoomHost && (<TimerValues
                setMinutes={setMinutes}
                setSeconds={setSeconds}
            />)}

            <div className="time_stamp_count">
                <h1>{initialMinutes < 10 ? `0${initialMinutes}` : initialMinutes}</h1>
                <h1>:</h1>
                <h1>{initialSeconds < 10 ? `0${initialSeconds}` : initialSeconds}</h1>
            </div>

            {isRoomHost && (
                <div className={!isTimeStamp ? `time_stamp_stop` : `time_stamp_start`} onClick={handlerTimeStamp}>
                    <span className="material-symbols-outlined icon_btn_time_stamp">{!isTimeStamp ? "play_circle" : "stop_circle"}</span>
                    <span>{!isTimeStamp ? "Iniciar treinamento" : "Parar treinamento"}</span>
                </div>)}

            <div id="id_timer_audio_alert"></div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setIsTimeStampAction: (isTimeStamp) => dispatch(setIsTimeStamp(isTimeStamp)),
    };
};

export default connect(mapStateToProps, mapStateActionToProps)(TimerStamp);